export const LIVE_SPEECH_SAMPLE_RATE = 24000;
export const LIVE_SPEECH_SAMPLES_PER_SUBCHUNK = 480;
export const END_OF_UTTERANCE_SILENCE_MS = 500;

export const getSilenceSubChunkDurationMs = (
  samplesPerSubChunk = LIVE_SPEECH_SAMPLES_PER_SUBCHUNK,
  sampleRate = LIVE_SPEECH_SAMPLE_RATE,
) => (samplesPerSubChunk / sampleRate) * 1000;

export const createSilentPcmSubChunk = (
  samplesPerSubChunk = LIVE_SPEECH_SAMPLES_PER_SUBCHUNK,
): Int16Array => new Int16Array(samplesPerSubChunk);

export const getTrailingSilenceChunkCount = (
  durationMs = END_OF_UTTERANCE_SILENCE_MS,
) =>
  Math.ceil(
    durationMs / getSilenceSubChunkDurationMs(LIVE_SPEECH_SAMPLES_PER_SUBCHUNK),
  );

export type TrailingSilenceCancel = () => void;

export const scheduleTrailingSilenceChunks = (
  sendChunk: (chunk: Int16Array) => void,
  onComplete: () => void,
  durationMs = END_OF_UTTERANCE_SILENCE_MS,
): TrailingSilenceCancel => {
  const chunkDurationMs = getSilenceSubChunkDurationMs();
  const chunkCount = Math.ceil(durationMs / chunkDurationMs);
  let sent = 0;

  const intervalId = window.setInterval(() => {
    sendChunk(createSilentPcmSubChunk());
    sent += 1;
    if (sent >= chunkCount) {
      window.clearInterval(intervalId);
      window.setTimeout(onComplete, chunkDurationMs);
    }
  }, chunkDurationMs);

  return () => {
    window.clearInterval(intervalId);
  };
};
